import { render, staticRenderFns } from "./lessonPlayPage.vue?vue&type=template&id=62bee65f&"
import script from "./lessonPlayPage.vue?vue&type=script&lang=ts&"
export * from "./lessonPlayPage.vue?vue&type=script&lang=ts&"
import style0 from "./lessonPlayPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports